if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", function () {
  const facetsForm = document.querySelector('.facets__form');
  if (!facetsForm) return;

  // Oculta todos los filtros a partir del 4º
  const hiddenFacets = facetsForm.querySelectorAll('.facets__disclosure-wrapper:nth-of-type(n+4)');
  hiddenFacets.forEach(el => el.style.display = 'none');

  // Crear botón
  const button = document.createElement('button');
  button.innerText = 'Ver más filtros';
  button.className = 'show-more-filters';

  // Insertar botón al final
  facetsForm.appendChild(button);

  button.addEventListener('click', function (e) {
    e.preventDefault();
    hiddenFacets.forEach(el => el.style.display = 'block');
    button.style.display = 'none';
  });
});
